import { assets } from "../assets";
import { connection } from "../connection";
import { display } from "../display";
import { dom } from "../dom";
import { memory } from "../memory";
import { assetHitRate } from "../assetHitRate";
import { akamaiHitRate } from "../akamaiHitRate";
import { pageMetaData } from "../pageMetaData";
import { version as client_version } from "../../version";

type PageInfo = Awaited<ReturnType<typeof assets>> &
    Awaited<ReturnType<typeof connection>> &
    Awaited<ReturnType<typeof display>> &
    Awaited<ReturnType<typeof dom>> &
    Awaited<ReturnType<typeof memory>> &
    Awaited<ReturnType<typeof assetHitRate>> &
    Awaited<ReturnType<typeof akamaiHitRate>> &
    Awaited<ReturnType<typeof pageMetaData>> & {
        url: string;
        trace_id?: string;
        language: string;
        referrer: string;
        client_version: string;
        elapsed: number;
    };

let pageInfo;

/**
 * @returns {dictionary<string, string|number>}
 */
export function getPageInfo(): PageInfo & { elapsed: number } {
    let info;
    if (!pageInfo) {
        pageInfo = new WeakRef(buildInfo());
    }
    info = pageInfo.deref();
    if (!info) {
        pageInfo = new WeakRef(buildInfo());
    }
    info = pageInfo.deref();
    info.elapsed = performance.now();
    return info;
}

/**
 * Gather information about the page
 */
function buildInfo(): PageInfo {
    return Object.assign(
        pageMetaData(),
        {
            url: window.location.href,
            trace_id: performance
                .getEntriesByType("navigation")
                ?.pop()
                ?.serverTiming?.find(({ name }) => name === "Trace-ID")
                ?.description,
            language: window.navigator.language || undefined,
            referrer: document.referrer || undefined,
            client_version,
        },
        assetHitRate(),
        akamaiHitRate(),
        assets(),
        connection(),
        memory(),
        display(),
        dom(),
    );
}
